import React, { useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    Button,
    FormControl,
    FormLabel,
    Input,
    Stack,
    Text,
    CloseButton,
    Box,
    HStack,
    InputGroup,
    InputRightElement,
    Link,
    Flex,
    VStack, useToast, Image, ListItem, ListIcon, List, ModalFooter
} from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";
import { FcRight } from "react-icons/fc";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { SERVER_IP } from "../../../utils/constants";
import {
    addDocument,
    removeDocument,
    setCeleryTaskID, setIsPricingModalOpen,
    setIsScanActuallyInProgress,
    setScanInProgress
} from "../../../redux/reducers";
import { addDocumentInStorage, getDocumentsInStorage } from "../../../utils/local-storage-helpers";
import { useAuth } from "../../../redux/AuthProvider";
import { StarIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Avatar, AvatarGroup } from "@chakra-ui/react";
import { useMemo } from "react";

const PricingScreen = ({ isOpenPricingScreen, onClosePricingScreen, onOpenPricingScreen }) => {
    const [isLoading, setIsLoading] = useState(false);
    const toast = useToast();
    const scanEstimatedSeconds = useSelector(state => state.settings.scanEstimatedSeconds)
    const scanFileID = useSelector(state => state.settings.scanFileID)
    const dispatch = useDispatch()
    const [intervalHook, setIntervalHook] = useState(0)
    const auth = useAuth();
    const navigate = useNavigate();
    const isPricingModalOpen = useSelector(state => state.settings.isPricingModalOpen)
    const { t } = useTranslation();

    const getWeeklyRandomNumber = () => {
        const now = new Date();
        const startOfYear = new Date(now.getFullYear(), 0, 1);
        const weekNumber = Math.ceil((((now - startOfYear) / 86400000) + startOfYear.getDay() + 1) / 7);

        const seed = now.getFullYear() + '-' + weekNumber;

        // Create a seeded pseudo-random number (deterministic per week)
        const hash = [...seed].reduce((acc, char) => acc + char.charCodeAt(0), 0);
        const random = (hash % 51) + 50; // Value between 50 and 100
        return random;
    };

    const weeklyJoinCount = useMemo(() => getWeeklyRandomNumber(), []);

    const closeModal = () => {
        onClosePricingScreen();
        dispatch(setIsPricingModalOpen(false))
    }

    return (
        <>
            <Modal isOpen={isPricingModalOpen} onClose={closeModal} isCentered size="xl">
                <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
                <ModalContent borderRadius="1rem" p="0.75rem" h="37rem" w="25rem" overflowY="auto" position="relative" boxShadow="1xl">
                    <Box
                        position="absolute"
                        top="10px"
                        right="10px"
                        zIndex={999}
                    >
                        <CloseButton
                            size="md"
                            onClick={() => {
                                onClosePricingScreen();
                                dispatch(setIsPricingModalOpen(false))
                            }}
                            bg="transparent"
                            borderRadius="50%"
                            _hover={{
                                bg: "gray.200",
                                borderRadius: "50%",
                            }}
                        />
                    </Box>






                    <ModalBody>
                        <Flex alignItems="center" justifyContent="space-between" p={3} pt={1} >
                            <VStack align="center" width={'100%'} spacing={3}>
                                <Text mb={-2} fontSize="1.6rem" fontWeight={'600'}>{t("Upgrade to Pro")}</Text>

                                <Image
                                    src="/smiley_faces.png" // Replace this with the actual URL of your GIF
                                    alt="Smiley Faces"
                                    boxSize="240px"
                                />

                                <HStack mb={-3} mt={-3}>
                                    <AvatarGroup size="xs" max={3}>
                                        <Avatar name="Edward" src="/alice.jpg" />
                                        <Avatar name="Olivia" src="/bob.jpg" />
                                        <Avatar name="John" src="/charlie.jpg" />
                                    </AvatarGroup>
                                    <Text fontSize={13} fontWeight={'600'}>
                                        {weeklyJoinCount.toLocaleString()} joined Pro this past week
                                    </Text>
                                </HStack>
                                <Box position="relative"
                                     left="0px"
                                     width="calc(100% + 36px)" >
                                    <svg width="100%" height="100%" viewBox="0 0 400 50" preserveAspectRatio="none">
                                        <defs>
                                            <linearGradient id="gradientLine" x1="0%" y1="0%" x2="100%" y2="0%">
                                                <stop offset="0%" stopColor="#FF7A18" />
                                                <stop offset="100%" stopColor="#AF002D" />
                                            </linearGradient>
                                        </defs>
                                        <path
                                            d="M10 35 Q 100 10 390 35"
                                            stroke="url(#gradientLine)"
                                            strokeWidth="8"
                                            fill="transparent"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </Box>



                                <VStack align="center" width={'100%'} spacing={6} mt={1}>
                                    {/*<Text fontSize={'md'} fontWeight={'600'}>{t("With the Pro Plan, get:")}</Text>*/}
                                    <List spacing={2} textAlign="start" justify={'flex-start'}>
                                        <ListItem key={1}>
                                            <Flex align="start">
                                                <ListIcon as={FaCheckCircle} color="green.500" mt={1} mr={3} />
                                                <Text fontSize={"md"} fontWeight={'500'}>{t("Unlimited chats")}</Text>
                                            </Flex>
                                        </ListItem>
                                        <ListItem key={2}>
                                            <Flex align="start">
                                                <ListIcon as={FaCheckCircle} color="green.500" mt={1} mr={3} />
                                                <Text fontSize={"md"} fontWeight={'500'}>{t("Unlimited file uploads")}</Text>
                                            </Flex>
                                        </ListItem>
                                        <ListItem key={3}>
                                            <Flex align="start">
                                                <ListIcon as={FaCheckCircle} color="green.500" mt={1} mr={3} />
                                                <Text fontSize={"md"} fontWeight={'500'}>{t("Up to 200 pages for scanned files")}</Text>
                                            </Flex>
                                        </ListItem>
                                    </List>
                                </VStack>
                            </VStack>
                        </Flex>
                    </ModalBody>
                    <ModalFooter>
                        <Flex width="100%" justify="center">
                            <Button
                                loadingText="Submitting"
                                size="lg"
                                isLoading={isLoading}
                                width={'100%'}
                                onClick={() => {
                                    onClosePricingScreen();
                                    dispatch(setIsPricingModalOpen(false))
                                    navigate('/pricing');
                                }}
                                bgGradient="linear(to-r, red.400,pink.400)"
                                _hover={{
                                    bgGradient: 'linear(to-r, red.400,pink.400)',
                                    boxShadow: 'lg',
                                }}
                                color={'white'}
                            >
                                {t("View Pricing")}
                            </Button>
                        </Flex>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

export default PricingScreen;







